import { defineComponent as _defineComponent } from 'vue'
import {
  nextTick,
  onMounted,
  onUnmounted,
  PropType,
  ref,
} from "vue";

import {
  createIssuerIdentityUser,
  CreateIssuerIdentityUserRequest,
} from "@/components/issuers/scripts/issuerIdentityUsers";

import {
  HelperFunctions,
  isEmpty
} from "@/scripts/Common/HelperFunctions";

import {
  useI18n
} from "@/composables";

import {
  isSmallerOrEqualToMaxLength
} from "@/scripts/Common/validators";

import {
  VForm
} from "vuetify/lib/components";

import {
  fetchIssuer
} from "../scripts/issuers";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddIssuerPortalUserDialog',
  props: {
  issuerId: {
    required: true,
    type: Number as PropType<number>
  }
},
  emits: [
  'onDialogCancel',
  'onDialogConfirm',
  'onFetchError'
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();





const form = ref<InstanceType<typeof VForm>>();

const request = ref<CreateIssuerIdentityUserRequest>({ email: '' });

const isValid = ref(true);
const isDialogVisible = ref(false);

const onHandleDialogCancel = () => {
  emits('onDialogCancel');
}

const handleIdentityUserAlreadyAssignedError = async (issuerId : number) => {
  let message = "";
  if (props.issuerId !== issuerId) { // user exists on another issuer

    // fetch company name for conflicting issuer
    let issuer = await fetchIssuer(issuerId);
    message = t("conflict_user_already_exists_on_other_issuer", { email: request.value.email, issuerName: issuer.response?.CompanyName });
  } else { // user exists on this issuer
    message = t("conflict_user_already_exists");
  }

  emits('onFetchError', { error: { error: message } });
}

const onHandleDialogError = async ({error} : { error : any}) => {
  if(error && error.ErrorCode === "ERR_IDENTITY_USER_ALREADY_ASSIGNED") {
    await handleIdentityUserAlreadyAssignedError(error.Data.IssuerId);
    return;
  }

  emits('onFetchError', {error});
}

const onHandleDialogConfirm = async () => {
  const { error } = await createIssuerIdentityUser(props.issuerId ,request.value);

  if (error) {
    await onHandleDialogError({error});
    return;
  }

  emits('onDialogConfirm');
}

const validateForm = () => form.value?.validate();

onMounted( async () => {
  isDialogVisible.value = true;
  await nextTick();
  validateForm();
});

onUnmounted(() => {
  isDialogVisible.value = false;
})


return { __sfc: true,t, emits, props, form, request, isValid, isDialogVisible, onHandleDialogCancel, handleIdentityUserAlreadyAssignedError, onHandleDialogError, onHandleDialogConfirm, validateForm, HelperFunctions, isEmpty, isSmallerOrEqualToMaxLength, VForm }
}

})